<template>
  <li :class="indicatorclass"
      @click="changeStep(step.id)">
    <div class="step">{{ step.id }}.</div>
    <div class="caption hidden-xs hidden-sm">
      {{ step.title }}
    </div>
  </li>
</template>
<script>
  export default {
    props: ['step', 'currentstep'],
    computed: {
      indicatorclass() {
        return {
          'active': (this.step.id === this.currentstep),
          'complete': (this.currentstep > this.step.id)
        }
      }
    },
    methods: {
      changeStep(step) {
        this.$emit('step-change', step)
      }
    }
  }
</script>
